import React from 'react';
import { NavLink } from 'react-router-dom';

function Sidebar() {
  const [expanded, setExpanded] = React.useState(false);
  const cx = ({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`;

  return (
    <div className="sidebar">
      <style>{`
        /* Don't change sizing. */
        .sidebar-widget-list-inner ul { list-style: none; padding: 0; margin: 0; }
        .sidebar-widget-list-inner li { margin: 0; position: relative; }

        .sidebar-link {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 1rem;
          text-decoration: none;
          color: inherit;
          border-left: 3px solid transparent;
          width: 100%;
          transition: color 0.2s ease, border-color 0.2s ease;
        }

        /* Hover highlight must span the whole row */
        .sidebar-widget-list-inner li:hover { background: rgba(0,0,0,0.035); }
        .sidebar-link:hover { background: none; } /* prevent partial highlight */

        /* Active color + full-row coverage */
        .sidebar-link.is-active { font-weight: 700; border-left-color: #e75934; background: transparent; }
        .sidebar-widget-list-inner li:has(> .sidebar-link.is-active) { background: #e75934; }
        .sidebar-widget-list-inner li:has(> .sidebar-link.is-active) .sidebar-link,
        .sidebar-widget-list-inner li:has(> .sidebar-link.is-active) i { color: #fff; }

        /* Fallback for browsers without :has() */
        @supports not(selector(:has(*))) {
          .sidebar-link.is-active { background: #e75934; color: #fff; }
          .sidebar-link.is-active i { color: #fff; }
        }

        /* "Need Assistance?" text should be white (bg already green elsewhere) */
        .sidebar-widget.sidebar-widget-card .sidebar-widget-card-content h3 a {
          color: #fff;
        }
        .sidebar-widget.sidebar-widget-card .sidebar-widget-card-content h3 a:hover {
          color: #fff;
          text-decoration: underline;
        }
      `}</style>

      <div className="sidebar-widget-list-inner">
        <ul>
          <li>
            <NavLink to="/department/dmv" className={cx}>
              Motor Vehicles
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/health" className={cx}>
              Health and Human Services
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/education" className={cx}>
              Education
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/employment" className={cx}>
              Employment and Workforce Development
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/housing" className={cx}>
              Housing and Community Development
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/family-services" className={cx}>
              Family and Children Services
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/public-safety" className={cx}>
              Public Safety
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/senior-services" className={cx}>
              Senior Services
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/veterans" className={cx}>
              Veterans Affairs
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/emergency" className={cx}>
              Emergency Management
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/department/technology" className={cx}>
              Innovation & Technology
              <i className="fa-solid fa-arrow-right-long" />
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="sidebar-widget sidebar-widget-card">
        <div className="sidebar-widget-card-icon">
          <i className="flaticon-question" />
        </div>

        <div className="sidebar-widget-card-content">
          <h3>
            <NavLink to="/contact">Need Assistance?</NavLink>
          </h3>
          <p>
            Have a question about any State of GTS service or program? Click "Need Assistance?" up above to contact us.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
